import React, {useState, useEffect} from 'react';
import { Link } from 'react-router-dom';
import './LandingPage.css';
import LandingHero from '../../assets/images/landing-hero.png';
import ScannerIcon from '../../assets/icons/scanner_icon.svg';
import UploadIcon from '../../assets/icons/upload_icon.svg';
import TrophyIcon from '../../assets/icons/trophy_icon2.svg';
import EditIcon from '../../assets/icons/edit_icon.svg';
import Typewriter from '../../utilities/typewriter';
import { Helmet } from 'react-helmet';

export default function LandingPage() {
  const [textVisible, setTextVisible] = useState(false);
  const [highlightStart, setHighlightStart] = useState(false);
  const [imageVisible, setImageVisible] = useState(false);

  useEffect(() => {
  setTextVisible(true);
  setTimeout(() => setHighlightStart(true), 300);
  setTimeout(() => setImageVisible(true), 600);
  }, []);

  return (
    <>
    <Helmet>
    <title>Resycle</title>
    </Helmet>
      <div className='landing-page'>
        <section className='hero-section'>
          <div className='hero-inner'>
            <div className={`hero-text ${textVisible ? 'fade-in' : ''}`}>
              <h1>Shift your job hunt into high gear <br/>
              <div className='highlight-wrapper'>
                  <span className='highlight'> 
                  {highlightStart && (
                  <Typewriter
                    text='Recycle. Rank. Repeat.'
                    speed={120}
                    delay={0}
                    cursor='|'
                    cursorBlinkSpeed={400}
                    loopDelay={7000}
                  />)}
                  </span>
                  </div>
                </h1>
              <p>Match resumes against job description keywords and watch the top one cross the finish line.</p>
              <div className='hero-buttons'>
              <Link to='/upload'><button className='btn-primary'>Get Started</button></Link>
              </div>
            </div>
          </div>
          <div className={`hero-image ${imageVisible ? 'fade-up' : ''}`}>
            <img src={LandingHero} alt='Landing Hero' />
          </div>
        </section>

        <section className='values-section'>
        <h2 className='values-intro'>PUT YOUR BEST FOOT FORWARD</h2>
          <div className='values-grid'>
            <div className='value-card'>
            <img src={UploadIcon} alt='Resume' />
              <h3>1. Upload your resume(s)</h3>
              <p> Add one (or a few) resume to match against.</p>
            </div>
            <div className='value-card'>
            <img src={ScannerIcon} alt='Job description' />
              <h3>2. Drop in the job description</h3>
              <p>Find the keywords that will make your resume stand out.</p>
            </div>
            <div className='value-card'>
              <img src={TrophyIcon} alt='Winning resume' />
              <h3>3. Find the best match</h3>
              <p>Take out the guesswork and watch as we rank the winning resumes. </p>
              
            </div>
            <div className='value-card'>
              <img src={EditIcon} alt='Edit resume' />
              <h3>4. Refine and edit keywords</h3>
              <p>Add or delete keywords to further refine the ranking. </p>
          
            </div>
          </div>
        </section>
      </div>
    </>
  );
}


